import React from "react";
import Header from "@vkontakte/vkui/dist/components/Header/Header";
import Group from "@vkontakte/vkui/dist/components/Group/Group";
import List from "@vkontakte/vkui/dist/components/List/List";
import { SimpleCell } from "@vkontakte/vkui";
import { connect } from "react-redux";

const UserInfoList = ({ userInfo }) => {
  return (
    <Group header={<Header mode="secondary">Личные данные </Header>}>
      <List>
        <SimpleCell>{userInfo.formattedName}</SimpleCell>
        <SimpleCell>{userInfo.email}</SimpleCell>
        <SimpleCell>{userInfo.mobile}</SimpleCell>
      </List>
    </Group>
  );
};

const mapStateToPros = (state) => {
  return {
    userInfo: state.userInfo.userInfo,
  };
};

export default connect(mapStateToPros)(UserInfoList);
